export default __webpack_public_path__ + "static/media/lessons-1.33d88415.png";